import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ParametrosEnum } from 'src/app/shared/enums/parameters.enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { ParameterService } from '../../services/parameter.service';
import { RatesSalesService } from '../../services/rates-sales.service';
import { AdminEditPermissionsService } from 'src/app/shared/services/admin-edit-permissions.service';

@Component({
  selector: 'app-set-rates-sales-parameters',
  templateUrl: './set-rates-sales-parameters.component.html',
  styleUrls: ['./set-rates-sales-parameters.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetRatesSalesParametersComponent implements OnInit {
  valueSL: number = 0;
  valueLQ: number = 0;
  discount1: number = 0;
  discount2: number = 0;

  public currentPage = 1;
  public pageSize = 25;
  public totalItems = 0;
  public totalPages = this.totalItems / this.pageSize;
  displayedColumns: string[] = ['fecha', 'hora', 'tasa'];
  dataSource: MatTableDataSource<any> | undefined;

  /** Candado de edición: en producción solo escribe el operador autorizado. */
  puedeEditar = false;

  constructor(
    private parametersService: ParameterService,
    private spinner: SpinnerService,
    private tasasService: RatesSalesService,
    private permisos: AdminEditPermissionsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.parametersService
      .getParameter(ParametrosEnum.VALOR_SOLVENCIA_SELL)
      .then((value) => {
        this.valueSL = value.valor;
        this.ratesForm.controls['valueSL'].setValue(value.valor);
      });
    this.parametersService
      .getParameter(ParametrosEnum.VALOR_LIQUIDEZ_SELL)
      .then((value) => {
        this.valueLQ = value.valor;
        this.ratesForm.controls['valueLQ'].setValue(value.valor);
      });
    this.parametersService
      .getParameter(ParametrosEnum.DESCUENTO_1_SELL)
      .then((value) => {
        this.discount1 = value.valor;
        this.ratesForm.controls['discount1'].setValue(value.valor);
      });
    this.parametersService
      .getParameter(ParametrosEnum.DESCUENTO_2_SELL)
      .then((value) => {
        this.discount2 = value.valor;
        this.ratesForm.controls['discount2'].setValue(value.valor);
      });
    this.initTasaValue();
  }
  ratesForm = new FormGroup({
    valueSL: new FormControl(),
    valueLQ: new FormControl(),
    discount1: new FormControl(),
    discount2: new FormControl(),
  });

  ngOnInit(): void {
    // Acá y no en el constructor: el FormGroup es un class field y no hay que
    // depender del orden de inicialización para tocarlo.
    this.aplicarPermisoEdicion(this.permisos.valorInicial);
    this.permisos.puedeEditar().then((puede) => this.aplicarPermisoEdicion(puede));
  }

  /**
   * Refleja el permiso en la pantalla: sin permiso, los campos quedan
   * deshabilitados además de los botones.
   */
  private aplicarPermisoEdicion(puede: boolean): void {
    this.puedeEditar = puede;
    if (puede) {
      this.ratesForm.enable({ emitEvent: false });
    } else {
      this.ratesForm.disable({ emitEvent: false });
    }
    this.cdr.markForCheck();
  }

  reset() {
    this.ratesForm.controls['valueSL'].setValue(this.valueSL);
    this.ratesForm.controls['valueLQ'].setValue(this.valueLQ);
    this.ratesForm.controls['discount1'].setValue(this.discount1);
    this.ratesForm.controls['discount2'].setValue(this.discount2);
  }

  showConfirm() {
    if (this.permisos.bloqueado(this.puedeEditar, 'Tu usuario no tiene permisos para modificar los parámetros de tasas.')) return;

    Swal.fire({
      title: '¿Está seguro de guardar los parámetros?',
      showCancelButton: true,
      confirmButtonText: `Guardar`,
      cancelButtonText: `Cancelar`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const ref = this.spinner.start();
        await this.setParameters();
        this.spinner.stop(ref);
        Swal.fire('Guardado', '', 'success');
      }
    });
  }

  async initTasaValue(): Promise<void> {
    const ref = this.spinner.start();
    const record = await this.tasasService.getRatesUsdtSales(
      this.currentPage,
      this.pageSize
    );
    this.dataSource = new MatTableDataSource(record.query);
    this.totalItems = +record.count;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.spinner.stop(ref);
  }

  async reload(): Promise<void> {
    this.currentPage = 1;
    this.initTasaValue();
    // await this.getFactorManual();
  }

  onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.initTasaValue();
  }
  async setParameters() {
    const valueSL = this.ratesForm.controls['valueSL'].value;
    const valueLQ = this.ratesForm.controls['valueLQ'].value;
    const discount1 = this.ratesForm.controls['discount1'].value;
    const discount2 = this.ratesForm.controls['discount2'].value;

    await Promise.all([
      this.parametersService.saveParameter(
        ParametrosEnum.VALOR_SOLVENCIA_SELL,
        valueSL
      ),
      this.parametersService.saveParameter(
        ParametrosEnum.VALOR_LIQUIDEZ_SELL,
        valueLQ
      ),
      this.parametersService.saveParameter(
        ParametrosEnum.DESCUENTO_1_SELL,
        discount1
      ),
      this.parametersService.saveParameter(
        ParametrosEnum.DESCUENTO_2_SELL,
        discount2
      ),
    ]);
    this.discount1 = discount1;
    this.discount2 = discount2;
    this.valueLQ = valueLQ;
    this.valueSL = valueSL;
  }
}
